import { UnassignRequest, UnassignResponse } from '@eigtech/assignments-types'
import { contextualRemove } from '@eigtech/ui-shared-api'
import { assignmentsBasePath } from './constants'

export const unassign = ({ assignableId, assigneeId, assigneeRelationship }: UnassignRequest) =>
  contextualRemove<UnassignResponse, null>(
    `${assignmentsBasePath}/${assignableId}/${assigneeId}/${assigneeRelationship}`,
    null,
    {
      responseType: 'none',
    }
  )
